import React from 'react';
import { connect } from 'react-redux';
import { startLogout } from '../actions/auth';
import { Redirect } from "react-router-dom";

export const LogoutPage = (props) => {
    const startLogout = props.startLogout;
    console.log("logout page loading startLogout = " + JSON.stringify(startLogout, null, 2));
    return (
        <Redirect to='/' />
    );
}

const mapDispatchToProps = (dispatch) => {
    console.log("logout page loading dispatch = " + JSON.stringify(dispatch, null, 2));
    return ({
        startLogout: () => dispatch(startLogout())
    });
}

export default connect(undefined, mapDispatchToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./src/components/LogoutPage.js